import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { Expense } from '../types/expense';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {

  constructor(private http: HttpClient,private env: EnvService ) { }

  getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/expenses/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }

   getAll():Observable <Expense[]> {
    return this.http.get <Expense[]>(`${this.env.apiUrl}/expenses`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    getAllExpBreakup():Observable <Expense[]> {
      return this.http.get <Expense[]>(`${this.env.apiUrl}/expenses/getAllExpBreakup`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }

      getAllExpNames():Observable <Expense[]> {
        return this.http.get <Expense[]>(`${this.env.apiUrl}/expenses/getAllExpNames`,httpOptions)
        .pipe(catchError(this.handleError));
           
        }
    getExpense(expNo):Observable <Expense> {
      return this.http.get<Expense>(`${this.env.apiUrl}/expenses/${expNo}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }



    addExpense(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/expenses`, data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    deleteExpense(expNo):Observable <any>{
      return this.http.delete<any>(`${this.env.apiUrl}/expenses/${expNo}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       


}
